import store from '@/store'

const cache = {
  /**
   * 载入全部信息
   */
  loadingCache: function () {
    if (localStorage.getItem('userInfo')) {
      store.commit('SET_USERINFO', JSON.parse(localStorage.getItem('userInfo')))
    }
  }
}

export default cache
